import React, { useState } from 'react';
import { Calendar, Wrench, Drop, Disc } from '@phosphor-icons/react';
import MyVehiclesTab from '../employee/MyVehiclesTab';
import NaprawyTab from '../admin/NaprawyTab';
import EmployeeWymianaOlejuTab from './EmployeeWymianaOlejuTab';
import OponyTab from '../shared/OponyTab';

export default function EmployeePojazdyTab() {
  const [subTab, setSubTab] = useState('terminy');

  return (
    <div>
      {/* Sub-tab Switcher */}
      <div className="mb-6 flex gap-2 border-b border-gray-200 overflow-x-auto">
        <button
          onClick={() => setSubTab('terminy')}
          className={`py-3 px-3 sm:px-6 whitespace-nowrap shrink-0 text-sm font-semibold border-b-2 -mb-px transition-colors ${
            subTab === 'terminy'
              ? 'border-blue-600 text-foreground'
              : 'border-transparent text-gray-600 hover:text-gray-900'
          }`}
        >
          <Calendar className="w-5 h-5 inline mr-2" />
          Terminy
        </button>
        <button
          onClick={() => setSubTab('naprawy')}
          className={`py-3 px-3 sm:px-6 whitespace-nowrap shrink-0 text-sm font-semibold border-b-2 -mb-px transition-colors ${
            subTab === 'naprawy'
              ? 'border-orange-600 text-orange-600'
              : 'border-transparent text-gray-600 hover:text-gray-900'
          }`}
        >
          <Wrench className="w-5 h-5 inline mr-2" />
          Naprawy
        </button>
        <button
          onClick={() => setSubTab('wymiana-oleju')}
          data-testid="emp-pojazdy-subtab-wymiana-oleju"
          className={`py-3 px-3 sm:px-6 whitespace-nowrap shrink-0 text-sm font-semibold border-b-2 -mb-px transition-colors ${
            subTab === 'wymiana-oleju'
              ? 'border-amber-600 text-amber-600'
              : 'border-transparent text-gray-600 hover:text-gray-900'
          }`}
        >
          <Drop className="w-5 h-5 inline mr-2" />
          Wymiana oleju
        </button>
        <button
          onClick={() => setSubTab('opony')}
          data-testid="emp-pojazdy-subtab-opony"
          className={`py-3 px-3 sm:px-6 whitespace-nowrap shrink-0 text-sm font-semibold border-b-2 -mb-px transition-colors ${
            subTab === 'opony'
              ? 'border-slate-800 text-slate-800'
              : 'border-transparent text-gray-600 hover:text-gray-900'
          }`}
        >
          <Disc className="w-5 h-5 inline mr-2" />
          Opony
        </button>
      </div>

      {/* Render appropriate sub-tab */}
      {subTab === 'terminy' && <MyVehiclesTab />}
      {subTab === 'naprawy' && <NaprawyTab />}
      {subTab === 'wymiana-oleju' && <EmployeeWymianaOlejuTab />}
      {subTab === 'opony' && <OponyTab />}
    </div>
  );
}
